import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "px-3 pt-3 pb-4" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "col-6 text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-mild test-weight-500 text-nowrap" }, "\n                キャンセル率\n              ", -1)
const _hoisted_7 = { class: "col-6 text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-mild test-weight-500 text-nowrap" }, "\n                直前キャンセル率\n              ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "p-3" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-mild text-size-12" }, "\n              直前キャンセル率…直近10回の応募したお仕事のうち、お仕事開始予定時刻の24時間前を過ぎた後に、ワーカー側の都合でキャンセルされたお仕事の割合\n            ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "canvas-wrapper position-relative" }, null, -1)
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "応募履歴"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-12 text-gray-05 ml-2" }, "\n            キャンセル率に含まれる直近10件の応募履歴\n          ")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-content-center my-5"
}
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_CancelPercentage = _resolveComponent("CancelPercentage")!
  const _component_CancelPercentageSudden = _resolveComponent("CancelPercentageSudden")!
  const _component_BgWaveCard = _resolveComponent("BgWaveCard")!
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      right: _withCtx(() => [
        _createElementVNode("a", { href: _ctx.faqURL }, [
          _createVNode(_component_FeatherIcon, {
            icon: "help-circle",
            size: "1x",
            class: "text-gray-05 mr-2"
          })
        ], 8, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      キャンセル率\n      ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BgWaveCard, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_CancelPercentage, {
                        percentage: _ctx.cancelPercentage,
                        numberSize: "10vmin",
                        unitSize: "6vmin",
                        numberClass: "text-weight-600",
                        unitClass: "text-weight-600"
                      }, null, 8, ["percentage"])
                    ]),
                    _createTextVNode(),
                    _hoisted_6
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_CancelPercentageSudden, {
                      percentage: _ctx.suddenCancelPercentage,
                      numberSize: "10vmin",
                      unitSize: "6vmin",
                      numberClass: "text-weight-600",
                      unitClass: "text-weight-600"
                    }, null, 8, ["percentage"]),
                    _createTextVNode(),
                    _hoisted_8
                  ])
                ]),
                _createTextVNode(),
                _hoisted_9,
                _createTextVNode(),
                _hoisted_10
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _hoisted_11
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(),
            _createElementVNode("div", null, [
              (!_ctx.hasApplications)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "\n            勤務履歴がありません\n          "))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (application) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: application.id,
                        class: "mt-3"
                      }, [
                        _createVNode(_component_RouterLink, {
                          to: {
                  name: 'ApplicationsDetail',
                  params: { applicationId: application.id.toString() }
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ApplicationCard, { application: application }, null, 8, ["application"])
                          ], undefined, true),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}